import cn from 'classnames';
import { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import s from './Backdrop.module.scss';

interface Props {
	isActive: boolean;
	onClick: any;
	increaseZIndexBy: number;
	children?: ReactNode;
}

export const Backdrop: FC<Props> = (props) => {
	const { isActive, onClick, increaseZIndexBy } = props;

	const content = (
		<div
			className={cn(s.container, isActive && s.container_active)}
			style={{
				zIndex: 400 + increaseZIndexBy,
			}}
			onClick={onClick}
		>
			{props.children}
		</div>
	);
	const container = document.getElementById('backdrop-portal') as HTMLElement;

	return ReactDOM.createPortal(content, container);
};
